import { headerLogoCenterBase64 } from './HeaderLogoStore.js';

export const updateHeaderLogoCenterBase64 = (value) => headerLogoCenterBase64.update((oldValue) => value);
